module.exports = __webpack_public_path__ + "img/21.ded205f7.jpg";